// src/utils/nodeHelpers.js

let incrementalId = 1;

export function getNewNodeId(existingIds) {
  if (!existingIds.includes("start")) {
    return "start";
  }
  let newId = `node_${incrementalId++}`;
  while (existingIds.includes(newId)) {
    newId = `node_${incrementalId++}`;
  }
  return newId;
}

export function getExistingNodeIds(workflowData) {
  if (!Array.isArray(workflowData)){
    console.error("NodeHelpers.js", "Invalid workflowData: Expected an array", workflowData);
    return [];
  }
  return workflowData.map((node) => node.id);
}